module.exports = __webpack_public_path__ + "img/home_design_consult.852653dc.jpg";